import {
  CheckCircle as CircleCheck,
  CloseCircle as CircleClose,
  CloseCircleF as CircleCloseFilled,
  Close,
  InfoCircleF as InfoFilled,
  Loading,
  CheckCircleF as SuccessFilled,
  ExclamationCircleF as WarningFilled,
} from '@jd/jdesign-icons-vue'
import { definePropType } from './props'

import type { Component } from 'vue'

export const iconPropType = definePropType<string | Component>([
  String,
  Object,
  Function,
])

export const CloseComponents = {
  Close,
}

export const TypeComponents = {
  Close,
  SuccessFilled,
  InfoFilled,
  WarningFilled,
  CircleCloseFilled,
}

export const TypeComponentsMap = {
  success: SuccessFilled,
  warning: WarningFilled,
  error: CircleCloseFilled,
  info: InfoFilled,
}

export const ValidateComponentsMap = {
  validating: Loading,
  success: CircleCheck,
  error: CircleClose,
}
